const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOAD_ENROLLMENT_FORM':
      return {
        ...action.form,
      };
    case 'CLEAR_ENROLLMENT_FORM':
      return initialState;
    default:
      return state;
  }
}
